import { BaseEventTracking } from '@/modules/core/app/models/abstracts/BaseEventTracking';
import { SegmentEvent } from '@/integrations/segment/SegmentEvent';

export class AdvisorPortalToolsOpened extends BaseEventTracking {
  static eventName: SegmentEvent = SegmentEvent.ADVISOR_PORTAL_TOOLS_OPENED;
}
